import { createAsyncAction } from "typesafe-actions";
import { GetTicketTransactionsRequest } from "../../models/ticket/GetTicketTransactionsRequest";
import { TicketListItem } from "../../models/ticket/TicketListItem";
import { GetLatestTicketTransactionsActionTypes, GetTicketTransactionsActionTypes } from "./types";

export const getTicketTransactionsActions = createAsyncAction(
    GetTicketTransactionsActionTypes.REQUEST,
    GetTicketTransactionsActionTypes.SUCCESS,
    GetTicketTransactionsActionTypes.ERROR
)<GetTicketTransactionsRequest, TicketListItem[], undefined>();

export const getLatestTicketTransactionsActions = createAsyncAction(
    GetLatestTicketTransactionsActionTypes.REQUEST,
    GetLatestTicketTransactionsActionTypes.SUCCESS,
    GetLatestTicketTransactionsActionTypes.ERROR
)<undefined, TicketListItem[], undefined>();
